import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IAgency from '../interfaces/IAgency';
import Layout from '~/components/Layout';



export default function Create() {
  const { register, handleSubmit, control, setValue: setFormValue, getValues, watch } = useForm<IAgency>();
  const fields = [
    { name: 'name', type: 'string', required: true },
    { name: 'acronym', type: 'string', required: true },
    { name: 'area_plan_id', type: 'selectAutoComplete', model: 'area-plan', placeholder: 'Mapa', required: true },
    { name: 'can_manage_any_agency', type: 'switch', checked: true, placeholder: 'Pode administrar qualquer agência', required: true, helperText: 'Com esse campo ativo, usuários desta agência poderão ter acesso, através do menu de Administração, de cadastros pertencentes a qualquer agência (como Usuários e Dispositivos). Caso contrário, informar quais agências ela poderá administrar, além dela mesma.' },
    { name: 'agencies_managed', type: 'selectAutoCompleteMultiple', model: 'agency', placeholder: 'Agencies to be managed' },
  ];

  return (
    <Layout marginLayout={true}>
      <CrudCreate
        watch={watch}
        model={'agency'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess={'Agency successfully created!'}
        title={'Add agency'}
        subheader={'Add a new agency'}
        setFormValue={setFormValue}
        getValues={getValues}
      />
    </Layout>
  )
}
